import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=48b28328&scoped=true&"
import script from "./ProductItem.vue?vue&type=script&lang=js&"
export * from "./ProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=48b28328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b28328",
  null
  
)

export default component.exports